var map = {
	"./img_1.jpg": 52430,
	"./img_10.jpg": 45876,
	"./img_2.jpg": 39215,
	"./img_3.jpg": 3640,
	"./img_4.jpg": 51296,
	"./img_5.jpg": 57417,
	"./img_6.jpg": 70214,
	"./img_7.jpg": 62839,
	"./img_8.jpg": 33174,
	"./img_9.jpg": 68639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52935;